import Vue from 'vue'
const $event = new Vue()

export default $event;
export { default as EVENT_NAME } from './event-name';

